<template>
    <detail-card @delete="$emit('delete')" :title="title" :card-color="cardColor" :readonly="readonly">
        <template v-for="field in fields">
            <template v-if="field.type === 'checkbox'">
                <v-checkbox :key="field.value" v-if="!isFiltered(field.value)" @change="$emit('change')" v-model="itemLocal[field.value]" :label="field.text" :rules="field.rules" :readonly="readonly" :disabled="disabled" />
            </template>
            <template v-else-if="field.type === 'date'">
                <v-text-field type="date" :key="field.value" v-if="!isFiltered(field.value)" @change="$emit('change')" v-model="itemLocal[field.value]" :label="field.text" :rules="field.rules" :readonly="readonly" :required="field.isRequired" :disabled="disabled" />
            </template>
            <template v-else-if="field.type === 'datetime'">
                <date-time-field :key="field.value" v-if="!isFiltered(field.value)" @input="$emit('change')" v-model="itemLocal[field.value]" :label="field.text" :rules="field.rules" :readonly="readonly" :required="field.isRequired" :hide-offset="true" :disabled="disabled" />
            </template>
            <template v-else-if="field.type === 'number'">
                <v-text-field type="number" :key="field.value" @change="$emit('change')" v-if="!isFiltered(field.value)" v-model="itemLocal[field.value]" :label="field.text" :rules="field.rules" :readonly="readonly" :required="field.isRequired" :disabled="disabled" />
            </template>
            <template v-else-if="field.type === 'time'">
                <v-text-field type="time" :key="field.value" v-if="!isFiltered(field.value)" @change="$emit('change')" v-model="itemLocal[field.value]" :label="field.text" :rules="field.rules" :readonly="readonly" :required="field.isRequired" :disabled="disabled" />
            </template>
            <template v-else-if="field.type === 'text'">
                <v-text-field :key="field.value" v-if="!isFiltered(field.value)" @change="$emit('change')" v-model="itemLocal[field.value]" :label="field.text" :rules="field.rules" :readonly="readonly" :required="field.isRequired" :counter="field.maxLength" :disabled="disabled" />
            </template>
            <template v-else-if="field.type === 'textarea'">
                <v-textarea :key="field.value" v-if="!isFiltered(field.value)" @change="$emit('change')" v-model="itemLocal[field.value]" :label="field.text" :rules="field.rules" :readonly="readonly" :required="field.isRequired" :counter="field.maxLength" :disabled="disabled" />
            </template>
            <template v-else-if="field.type === 'autocomplete'">
                <autocomplete :key="field.value" v-if="!isFiltered(field.value)" @input="$emit('change')" v-model="itemLocal[field.value]" :label="field.text" :rules="field.rules" item-text="label" item-value="id" :url="'/api/'+field.apiMethod+'/Autocomplete'" :addForm="field.form" :filter="filter" :disabled="disabled" :readonly="readonly" />
            </template>
            <template v-else-if="field.type === 'enum'">
                <v-select :key="field.value" v-if="!isFiltered(field.value)" @change="$emit('change')" v-model="itemLocal[field.value]" :items="field.items" :label="field.text" :rules="field.rules" :required="field.isRequired" :disabled="disabled" :readonly="readonly" />
            </template>
            <template v-else-if="field.type === 'coordinates'">
                <coordinate-picker :key="field.value" v-if="!isFiltered(field.value)" @change="$emit('change')" v-model="itemLocal[field.value]" :items="field.items" :label="field.text" :rules="field.rules" :disabled="disabled" :readonly="readonly" />
            </template>
            <template v-else-if="field.type === 'contact'">
                <contact-fields :key="field.value" v-if="!isFiltered(field.value)" v-model="itemLocal[field.value]" :contact-id="itemLocal[field.contactField]" :label="field.text" :rules="field.rules" :readonly="readonly" />
            </template>
            <template v-else-if="field.type === 'file'">
                <file-upload :key="field.value" v-if="!isFiltered(field.value)" @input="$emit('change')" v-model="itemLocal[field.value]" :label="field.text" :readonly="readonly" :disabled="disabled" />
            </template>
            <template v-else-if="field.type === 'files'">
                <files-field :key="field.value" v-if="!isFiltered(field.value)" @change="$emit('change')" v-model="itemLocal[field.value]" :form="field.form" :item-id="itemLocal.id" :parent-column-name="field.parentColumnName" :label="field.text" :readonly="readonly" :disabled="disabled" @save="save()" :can-open="!isSaving" />
            </template>
            <template v-else-if="field.type === 'custom'">
                <slot name="field" :item="itemLocal" @change="$emit('change')" :disabled="disabled" />
            </template>
        </template>
    </detail-card>
</template>

<script>
    export default {
        props: [
            'item',
            'cardColor',
            'fields',
            'title',
            'filter',
            'readonly',
            'disabled'
        ],

        components: {
            detailCard: () => import('../components/DetailCard'),
            autocomplete: () => import('../components/Autocomplete'),
            dateTimeField: () => import('../components/DateTimeField'),
            contactFields: () => import('../components/ContactFields'),
            fileUpload: () => import('../components/FileUpload'),
            filesField: () => import('../components/FilesField')
        },

        data() {
            return {
                isSaving: false,
            }
        },

        methods: {
            isFiltered(property) {
                if (typeof this.filter === 'undefined' || this.filter === null) {
                    return false;
                }

                return this.filter.hasOwnProperty(property);
            },

            async save() {
                this.isSaving = true;
                var self = this;
                setTimeout(() => { self.isSaving = false; }, 200)
            }
        },
        computed: {
            canSave() {
                if (this.itemLocal === null || typeof (this.itemLocal) === "undefined") {
                    return false;
                }
                return this.fields.filter(f => f.isRequired).every(f => this.itemLocal[f.value]);
            },
            itemLocal: {
                get() {
                    return this.item;
                },
                set(value) {
                    this.$emit("input", value);
                },
            },
        }
    };
</script>
